import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PlaceholdersService } from 'src/app/services/placeholders/placeholders.service';


@Pipe({
  name: 'placeholderHighlight',
  pure: false
})
export class PlaceholderHighlightPipe implements PipeTransform {

  // {Token} -> captures "Token"
  private readonly tokenRegex = /\{([a-zA-Z0-9_]+)\}/g;

  constructor(
    private sanitizer: DomSanitizer,
    private placeholdersService: PlaceholdersService) {

  }

  transform(value: string | null | undefined, editor: boolean = false): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const html = value.replace(this.tokenRegex, (match: string, _token: string) => {
      // If your service expects "{Token}" keep 'match'; if it expects "Token", pass _token.
      const raw = this.placeholdersService.getValue(match); // or getValue(_token)
      if (raw !== undefined && raw !== null && raw !== '' && !editor) {
        return `<b style="border-bottom:1px dotted #ddd; color:#285E87">${this.escapeHtml(String(raw))}</b>`;
      } else {
        return `<b style="color:#E04E39">${this.escapeHtml(match)}</b>`;
      }
    });

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private escapeHtml(s: string): string {
    return s.replace(/[&<>"']/g, ch =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } as const)[ch]!
    );
  }
}
